
import { Button } from "@/components/ui/button";
import { Calendar, MessageCircle, BookOpen, Users, Phone, Mail } from "lucide-react";
import { openGoogleCalendar } from "@/lib/utils";

export function LinksList() {
  const handleWhatsAppClick = () => {
    window.open("https://wa.me/5511998874081", "_blank");
  };

  const links = [
    {
      title: "Agendar Consulta",
      description: "Marque sua consulta online",
      icon: Calendar,
      action: openGoogleCalendar,
      color: "bg-white hover:bg-white/90 text-brand-primary",
    },
    {
      title: "WhatsApp",
      description: "Fale comigo diretamente",
      icon: MessageCircle,
      action: handleWhatsAppClick,
      color: "bg-brand-primary hover:bg-brand-primary/90 text-white",
    },
    {
      title: "Blog de Nutrição",
      description: "Dicas e receitas saudáveis",
      icon: BookOpen,
      url: "/blog",
      color: "bg-white hover:bg-white/90 text-brand-primary",
    },
    {
      title: "Grupo VIP",
      description: "Comunidade exclusiva no Telegram",
      icon: Users,
      url: "#",
      color: "bg-white hover:bg-white/90 text-brand-primary",
    },
    {
      title: "Teleconsulta",
      description: "Atendimento online",
      icon: Phone,
      action: openGoogleCalendar,
      color: "bg-white hover:bg-white/90 text-brand-primary",
    },
    {
      title: "E-book Gratuito",
      description: "Guia completo de alimentação",
      icon: Mail,
      url: "#",
      color: "bg-brand-secondary hover:bg-brand-secondary/90 text-white",
    },
  ];

  return (
    <>
      <div className="space-y-4 mb-8">
        {links.map((link, index) => (
          <Button
            key={index}
            className={`w-full h-auto p-4 ${link.color} transition-all duration-300 hover:scale-105 hover:shadow-lg border-0`}
            variant="outline"
            onClick={link.action}
            asChild={!link.action}
          >
            {link.action ? (
              <div className="flex items-center justify-start text-left w-full">
                <link.icon className="w-5 h-5 mr-3 flex-shrink-0" />
                <div className="flex-1">
                  <div className="font-semibold">{link.title}</div>
                  <div className="text-sm opacity-80">{link.description}</div>
                </div>
              </div>
            ) : (
              <a href={link.url} className="flex items-center justify-start text-left w-full">
                <link.icon className="w-5 h-5 mr-3 flex-shrink-0" />
                <div className="flex-1">
                  <div className="font-semibold">{link.title}</div>
                  <div className="text-sm opacity-80">{link.description}</div>
                </div>
              </a>
            )}
          </Button>
        ))}
      </div>
    </>
  );
}
